const UPDATE_NOTICE_API_URL =
  "/api/updatenotices";

function getErrorMessage(payload, status) {
  if (
    payload &&
    typeof payload === "object"
  ) {
    return (
      payload.detail ||
      payload.message ||
      payload.error ||
      `HTTP ${status}`
    );
  }

  return (
    String(payload || "").trim() ||
    `HTTP ${status}`
  );
}

async function requestJson(
  path,
  options = {}
) {
  const response = await fetch(
    path,
    {
      credentials: "include",
      ...options,

      headers: {
        Accept: "application/json",

        ...(options.body
          ? {
              "Content-Type":
                "application/json"
            }
          : {}),

        ...options.headers
      }
    }
  );

  const contentType = String(
    response.headers.get(
      "content-type"
    ) || ""
  ).toLowerCase();

  /*
   * 프록시가 적용되지 않으면 React index.html이
   * 반환될 수 있습니다.
   *
   * 기존 코드에서는 이 경우 null을 반환해서
   * "공지 없음"으로 잘못 표시됐습니다.
   */
  if (
    !contentType.includes(
      "application/json"
    )
  ) {
    const text =
      await response.text();

    throw new Error(
      [
        "업데이트 공지 API가 JSON이 아닌 응답을 반환했습니다.",
        `요청 주소: ${path}`,
        `상태 코드: ${response.status}`,
        `응답 형식: ${contentType || "unknown"}`,
        text
          ? `응답 앞부분: ${text.slice(0, 150)}`
          : ""
      ]
        .filter(Boolean)
        .join("\n")
    );
  }

  const payload =
    await response.json();

  if (!response.ok) {
    throw new Error(
      getErrorMessage(
        payload,
        response.status
      )
    );
  }

  return payload;
}

function unwrapResponseData(payload) {
  /*
   * API가 배열을 그대로 반환하는 경우
   */
  if (Array.isArray(payload)) {
    return payload;
  }

  /*
   * Hi-Portal 표준 응답:
   * {
   *   success: true,
   *   data: [...]
   * }
   */
  if (
    payload &&
    Array.isArray(payload.data)
  ) {
    return payload.data;
  }

  /*
   * 다른 응답 형태 대응:
   * {
   *   notices: [...]
   * }
   */
  if (
    payload &&
    Array.isArray(payload.notices)
  ) {
    return payload.notices;
  }

  return payload;
}

function unwrapObjectData(payload) {
  if (
    payload &&
    typeof payload === "object" &&
    payload.data &&
    typeof payload.data === "object"
  ) {
    return payload.data;
  }

  return payload;
}

export async function getUpdateNotices(
  language = "ko"
) {
  const query =
    new URLSearchParams({
      lang: language
    });

  const payload =
    await requestJson(
      `${UPDATE_NOTICE_API_URL}?${query.toString()}`
    );

  const notices =
    unwrapResponseData(payload);

  if (!Array.isArray(notices)) {
    console.error(
      "[updateNoticeService] Unexpected list response:",
      payload
    );

    throw new Error(
      "업데이트 공지 API 응답이 배열 형식이 아닙니다."
    );
  }

  return notices;
}

export async function getUpdateNotice(
  id,
  language = "ko"
) {
  const query =
    new URLSearchParams({
      lang: language
    });

  const payload =
    await requestJson(
      `${UPDATE_NOTICE_API_URL}/${encodeURIComponent(id)}?${query.toString()}`
    );

  return unwrapObjectData(payload);
}

export async function saveUpdateNotice(
  payload
) {
  const response =
    await requestJson(
      UPDATE_NOTICE_API_URL,
      {
        method: "POST",
        body: JSON.stringify(payload)
      }
    );

  return unwrapObjectData(response);
}

export async function deleteUpdateNotice(
  id
) {
  const response =
    await requestJson(
      `${UPDATE_NOTICE_API_URL}/${encodeURIComponent(id)}`,
      {
        method: "DELETE"
      }
    );

  return unwrapObjectData(response);
}

export async function checkUpdateNoticeAdminSession() {
  const response =
    await requestJson(
      `${UPDATE_NOTICE_API_URL}/admin-session`,
      {
        method: "GET"
      }
    );

  return unwrapObjectData(response);
}